<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <span class="inline-block size-10">
    <svg class="block size-full animate-spin" viewBox="0 0 24 24">
      <circle
        class="opacity-25"
        cx="12"
        cy="12"
        r="10"
        fill="none"
        stroke="currentColor"
        :stroke-width="strokeWidth"
      ></circle>
      <path
        class="opacity-75"
        fill="none"
        stroke="currentColor"
        :stroke-width="strokeWidth"
        d="M12 2
         A10 10 0 0 1 22 12"
      ></path>
    </svg>
  </span>
</template>
<script setup lang="ts">
const { strokeWidth = 4 } = defineProps<{ strokeWidth?: number }>();
</script>
